import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Banner.css";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const fade = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.7 } },
};

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="impact-banner" aria-label="Impact banner">
      <div className="impact-blob one" aria-hidden="true" />
      <div className="impact-blob two" aria-hidden="true" />

      <div className="impact-wrap">
        <motion.div
          className="impact-left"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.5 }}
        >
          <div className="impact-badge">
            <span className="dot" aria-hidden="true" />
            Results That Matter
          </div>

          <h2 className="impact-title">
            Turn your website into a <span>lead machine</span>.
          </h2>

          <p className="impact-sub">
            Setup Help Online builds digital assets that don't just exist online —
            they actively attract customers, rank on search engines, and convert
            visitors into paying clients.
          </p>

          <ul className="impact-trust">
            <li>Higher search rankings</li>
            <li>More qualified leads</li>
            <li>Faster page load times</li>
            <li>Measurable ROI tracking</li>
          </ul>

          <div className="impact-actions">
            <button className="impact-btn primary" onClick={() => navigate("/contact")}>
              Get Started Today <span aria-hidden="true">→</span>
            </button>
            <button className="impact-btn secondary" onClick={() => navigate("/services")}>
              See Our Work
            </button>
          </div>
        </motion.div>

        <motion.div
          className="impact-right"
          variants={fade}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.35 }}
        >
          <div className="impact-card">
            <div className="impact-cardTop">
              <div>
                <p className="impact-cardKicker">Client results</p>
                <h3 className="impact-cardTitle">Average project outcomes</h3>
              </div>
              <span className="impact-chip">Real data</span>
            </div>

            <div className="impact-metrics">
              <div className="metric">
                <b>+45%</b>
                <span>Average traffic increase</span>
              </div>
              <div className="metric">
                <b>+32%</b>
                <span>Lead conversion improvement</span>
              </div>
              <div className="metric">
                <b>1.5s</b>
                <span>Average page load time</span>
              </div>
              <div className="metric">
                <b>Top 10</b>
                <span>Google rankings achieved</span>
              </div>
            </div>

            <ul className="impact-list">
              <li><i>✓</i> Mobile-responsive design on every project</li>
              <li><i>✓</i> SEO optimization included in every build</li>
              <li><i>✓</i> Google Analytics & Search Console setup</li>
              <li><i>✓</i> 30 days free post-launch care</li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Banner;
